import * as React from 'react'
import * as styles from './AdsCarousel.module.scss'
import * as cn from 'classnames'
import { Link, Text } from 'DVWebNodeUI'
// @ts-ignore
import { StorefrontStateItem } from '../../../containers/Storefront';


const AdBox = ({ link, image, content, title }: StorefrontStateItem) => {
  if (!content || content.schemaType !== 'html' || !link || !link.url) {
    return null
  }
  const { dvStringSubtext, dvStringText } = content
  return (
    <div className={styles.AdBox}>
      <div className={styles.AdPackshot}>
        <a href={link.url}>
          <img src={image.url} />
        </a>
      </div>
      <div className={styles.AdDescription}>
        <h4><a href={link.url}>{title}</a></h4>
        <Text string={dvStringSubtext} />
        <Link
          href={link.url}
          text={<Text string={dvStringText} />}
        />
      </div>
    </div>
  )
}

const AdsCarousel = ({ left, right }: { left: StorefrontStateItem, right: StorefrontStateItem }) => (
  <div className={cn(styles.AdsCarousel, 'tst-ads-carousel')}>
    <AdBox {...left} />
    <AdBox {...right} />
  </div>
)

export default AdsCarousel
